import React, { useContext } from "react";
import style from "./index.module.scss";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import { QuestionnaireInfo, StuInfo } from "service/question";
import { Button } from "antd";
import { CourseContext } from "../../../../../../Store";
import { useHistory } from "react-router-dom";
import { isTrue } from "../../../../../../../../service/service";

interface StuListProps {
    questionnaireId: number;
    data: StuInfo[];
    pageData: QuestionnaireInfo | null;
}

export default function StuList({
    data,
    questionnaireId,
    pageData
}: StuListProps) {
    const { basename } = useContext(CourseContext);
    const history = useHistory();

    function isJoin(item: StuInfo): boolean {
        return parseInt(item.stuStatus) === 1;
    }

    function gotoReview(studentNo: string) {
        history.push(
            `${basename}/question/students/${questionnaireId}/review/${studentNo}`
        );
    }

    return (
        <div className={style.root}>
            {data.length > 0 &&
                data.map(item => (
                    <div className={style.item} key={item.studentId}>
                        <div className={style.student}>
                            <div className={style.name}>{item.name}</div>
                            <div className={style.stuNo}>{item.studentId}</div>
                        </div>

                        <div className={style.operate}>
                            <div
                                className={`${
                                    isJoin(item)
                                        ? style.status
                                        : style.statusEmpty
                                }`}>
                                {isJoin(item) ? "已参与" : "--"}
                            </div>

                            {!isTrue(pageData?.anonymityFlag) && (
                                <Button
                                    type="link"
                                    className={style.detail}
                                    disabled={!isJoin(item)}
                                    onClick={() => gotoReview(item.studentId)}>
                                    {isJoin(item) ? "查看" : "--"}
                                </Button>
                            )}
                        </div>
                    </div>
                ))}
            {data.length < 1 && <CustomEmpty description="无数据" />}
        </div>
    );
}
